import React, { useEffect, useState } from "react";
import "./RelatedAIArticles.css";

function RelatedAIArticles() {
  const [posts, setPosts] = useState([]);

  useEffect(() => {

    async function fetchPosts() {
      try {

        // obtener ID categoría inteligencia-artificial
        const categoryRes = await fetch(
          "https://blog.juancarlosmancharamos.ar/wp-json/wp/v2/categories?slug=inteligencia-artificial"
        );

        const categoryData = await categoryRes.json();

        if (!categoryData.length) return;

        const categoryId = categoryData[0].id;

        // traer últimos 3 posts
        const postsRes = await fetch(
          `https://blog.juancarlosmancharamos.ar/wp-json/wp/v2/posts?categories=${categoryId}&per_page=3&_embed`
        );

        const postsData = await postsRes.json();

        setPosts(postsData);

      } catch(err) {
        console.log(err);
      }
    }

    fetchPosts();

  }, []);

  return (
    <section className="related-ai">
	 <div className="container text-center">
      <h2>Recursos y guías sobre Inteligencia Artificial</h2>

      <p>
        Explorá contenido relacionado sobre IA aplicada a negocios,
        automatización y nuevas tecnologías.
      </p>

      <div className="articles-grid">

        {posts.map(post => {

          const image =
            post._embedded?.["wp:featuredmedia"]?.[0]?.source_url;

          return (

            <a
              key={post.id}
              href={post.link}
              target="_blank"
              rel="noopener noreferrer"
              className="article-card"
            >

              {image && (
                <img
                  src={image}
                  alt={post.title.rendered}
                  loading="lazy"
                />
              )}

              <h3
                dangerouslySetInnerHTML={{
                  __html: post.title.rendered
                }}
              />

            </a>

          );

        })}

      </div>
	 </div>
    </section>
  );
}

export default RelatedAIArticles;